<div class="form-modal">
  <h1 mat-dialog-title>{{'FILTERS'|translate}}</h1>
  <div mat-dialog-content>
    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12 no-padding">
        <!-- requestNumber -->
        <div class="col-lg-12 col-md-12 col-sm-12">
          <mat-form-field class="allwidth">
            <mat-label>{{ 'REQUEST_NUMBER' | translate}}</mat-label>
            <input matInput [(ngModel)]="requestNumber">
          </mat-form-field>
        </div>

        <div class="col-lg-12 col-md-12 col-sm-12 spacer-bottom-xs"></div>
      </div>
    </div>

  </div>
  <div mat-dialog-actions>
    <div class="full-width text-right modal-theme">
      <button type="button" class="btn btn-default" title="{{'BUTTON.CANCEL' | translate}}" (click)="dialogRef.close(null)">
        {{'BUTTON.CANCEL' | translate}}
      </button>
      <button type="button" class="btn btn-primary" title="{{'BUTTON.OK' | translate}}" (click)="dialogRef.close(requestNumber)">
        {{'BUTTON.OK' | translate}}
      </button>
    </div>
  </div>
</div>